import { render, staticRenderFns } from "./SeriesDetails.vue?vue&type=template&id=e9cfbd50"
import script from "./SeriesDetails.vue?vue&type=script&lang=js"
export * from "./SeriesDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports